import { useLocation } from 'react-router';
import siteTypeFactory from './SiteTypeFactory';

const SiteType = ({ sitesReady, realm, noSiteView }) => {
  const location = useLocation();
  const urlParameters = new URLSearchParams(location.search);
  const createSiteType = urlParameters.get('createSite') || 'default';

  return siteTypeFactory({
    realm,
    sitesReady,
    urlParams: urlParameters,
    type: createSiteType.toLowerCase(),
    noSiteView,
  });
};

export default SiteType;
